import ProfileService from "../services/ProfileService";
import { Dispatch } from "redux";
import { ProfileActions } from "../reducers/profile/actions";
import { ApplicationState } from "../reducers";

export enum ProfileActionTypes {
    PROFILE_SUCCESS = "profiles/PROFILE_SUCCESS",
    UPDATE_PROFILE_SUCCESS = "profile/UPDATE_PROFILE_SUCCESS",
}

export const loadProfile = () => {
    return async (dispatch: Dispatch) => {
        try {
            const response = await ProfileService.get();
            //dispatch({ type: ProfileActionTypes.PROFILE_SUCCESS, data: response.data });
            dispatch<ProfileActions>({
                type: "profile/fetch-success",
                data: response.data,
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    };
};

export function updateProfile(data: any) {
    return async (dispatch: Dispatch) => {
        try {
            const response = await ProfileService.update(data);
            dispatch({
                type: ProfileActionTypes.UPDATE_PROFILE_SUCCESS,
                data: response.data,
            });
            dispatch<ProfileActions>({
                type: "profile/update-success",
                data: response.data,
            });
        } catch (error) {
            throw error;
        }
    };
}

export function refetchProfile(updatedAt: string) {
    return (dispatch: Dispatch, getState: () => ApplicationState) => {
        const { profile } = getState();
        if (profile.updated_at !== updatedAt) {
            dispatch<any>(loadProfile());
        }
    };
}

export function enrolled() {
    return async () => {
        try {
            await ProfileService.enrolled();
        } catch (error) {
            if (error instanceof Error) alert(error.message);
        }
    };
}

export function notEnrolled() {
    return async () => {
        try {
            await ProfileService.notEnrolled();
        } catch (error) {
            if (error instanceof Error) alert(error.message);
        }
    };
}

export function initializeProfile(data: any) {
    return async () => {
        try {
            await ProfileService.initializeProfile(data);
        } catch (error) {
            throw error;
        }
    };
}
